import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from '../../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.ContainsGypsum`]: 'Contains Gypsum',
      [`${prefix}.Preparation.GrainSize`]: 'Grain Size',

      [`${prefix}.Equipment.Balance`]: 'Balance',
      [`${prefix}.Equipment.Oven`]: 'Oven',
      [`${prefix}.Equipment.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.Equipment.DryingTemperature`]: 'Drying Temperature',

      [`${prefix}.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.DryingTray.WetSoilAndContainerMass`]: 'Tare and Material Wet Mass',
      [`${prefix}.DryingTray.WetSoilMass`]: 'Material Wet Mass',
      [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: 'Tare and Material Dry Mass',
      [`${prefix}.DryingTray.ConstantDrySoilMass`]: 'Material Dry Mass',

      [`${prefix}.DryingTray.DateTimePlacedInOvenLocal`]: `Date and Time in Oven`,

      [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: `Tare and Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: `Material Dry Mass`,
      [`${prefix}.DryingTray.DryMassReadings.DateTimeRemovedFromOvenLocal`]: `Date and Time Out of Oven`,
      [`${prefix}.DryingTray.DryMassReadings.DryingTime`]: `Drying Time`,

      [`${prefix}.Results.MoistureContentPercent`]: 'Moisture Content',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Results.MoistureContentPercent`]: '%',
    })
  );

export default getLabelConfig;
